import { render, staticRenderFns } from "./UserSafety.vue?vue&type=template&id=3fd2016e&scoped=true&"
import script from "./UserSafety.vue?vue&type=script&lang=js&"
export * from "./UserSafety.vue?vue&type=script&lang=js&"
import style0 from "./UserSafety.vue?vue&type=style&index=0&id=3fd2016e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd2016e",
  null
  
)

export default component.exports